import Vue from 'vue';
import Component from 'vue-class-component';
import { Client, ICalculatedProductPrice, ProductPriceKey, ProductViewModel } from 'Api/CoreApi';
import { Prop } from 'vue-property-decorator';
import ABaseComponent from 'Components/Base/ABaseComponent';
import { State, Getter, Action } from 'vuex-class';
import { PorterBuilderState } from "Store/types";
import ApiProvider from 'Api/ApiProvider';
import { Dictionary } from 'vuex';
import porterBuilder from 'Store/porterbuilder/porterbuilder';
import productList from 'Store/productList/productList';

@Component({
    template: '#product-matrix-template'
})

export default class ProductMatrixComponent extends ABaseComponent {

    @Prop({ default: "" })
    productId: string;
    @Prop({ default: "" })
    productName: string;
    @Prop({ default: "" })
    languageId: string;
    @Prop({ default: false })
    forceLoadMatrix: boolean;
    @Prop({ default: true })
    hidePrices: boolean;
    @Prop()
    groupCodeIsOldModel: boolean;

    @State("porterBuilder")
    private porterBuilder: PorterBuilderState;

    sizes: Array<string> = [];
    subsizes: Array<string> = [];
    units: Array<string> = [];
    productMatrix: Array<any> = [];
    hasSubsizes: boolean = false;

    baseUnit: string = "";

    variantsDictionary: { [itemNo: string]: string } = {};
    shouldLoadMatrix: boolean = true;



    error: string = '';

    created() {

        if (this.forceLoadMatrix) {
            this.load();
        }
    }

    loadMatrix() {
        if (this.shouldLoadMatrix) {
            this.load();
        }
    }

    mounted() {
        this.$root.$on('loadProductMatrix', (productId: string) => {
            if (productId == this.productId) {
                this.loadMatrix();
            }
        });
    }

    getItemNumber(subSizeIdx: number, sizeIdx: number) {
        if (this.productMatrix[subSizeIdx][sizeIdx]) {
            return this.productMatrix[subSizeIdx][sizeIdx].num;
        }
        return "";
    }

    getVariantId(subSizeIdx: number, sizeIdx: number) {
        if (this.productMatrix[subSizeIdx][sizeIdx]) {
            return this.productMatrix[subSizeIdx][sizeIdx].variant;
        }
        return "";
    }

    isProductEntryNotNull(index1: number, index2: number) {
        return this.productMatrix[index1][index2] !== null;
    }
    isNumOldModelSales(productnumber: string): boolean {
        if (porterBuilder.state.porterItems && porterBuilder.state.porterItems.porterItems.some(x => x.porterItem.itemNo == productnumber)) {
            return true;
        }
        return false;

    }
    public allUnits: IBasicMetricViewModel[] = [];

    public findInStk(unit : string ) {
        let stkUnit = this.allUnits.find(x => x.Unit == 'STK');
        let currentUnit = this.allUnits.find(x => x.Unit == unit);
        if(stkUnit){
            return currentUnit.QtyPerUnit / stkUnit.QtyPerUnit;
        }else{
            return currentUnit.QtyPerUnit;
        }
    }
    public get stkExists() {
        return this.allUnits.some(x => x.Unit == 'STK');
    }
    public get baseUnitIsStk(): boolean {
        if (this.allUnits.length > 0)
            return this.allUnits[0].BaseUnitName === 'STK';
        return false;
    }



    async load() {
        this.setLoading();
        const client = ApiProvider.getApiClient();

        client.getProductMatrixById(this.languageId, this.productId)
            .then(result => {
                this.sizes = result.productVariants.sort((a, b) => { return a.basicMetrics.SizeSortingOrder - b.basicMetrics.SizeSortingOrder }).map(x => x.basicMetrics.Size).filter(distinct);;
                this.subsizes = result.productVariants.sort((a, b) => { return a.basicMetrics.SubSizeSortingOrder - b.basicMetrics.SubSizeSortingOrder }).map(x => x.basicMetrics.Subsize).filter(distinct);

                this.hasSubsizes = this.subsizes.length > 1 || (this.subsizes.length === 1 && this.subsizes[0] !== "");

                for (var i: number = 0; i < this.subsizes.length; i++) {
                    this.productMatrix[i] = [];
                    for (var j: number = 0; j < this.sizes.length; j++) {
                        this.productMatrix[i][j] = null;
                    }
                }
                for (let i = 0; i < result.productVariants.length; i++) {
                    let variantIsOldModel = this.groupCodeIsOldModel;
                    let metric = result.productVariants[i].basicMetrics;

                    this.units.push(metric.Unit);
                    this.allUnits.push(<IBasicMetricViewModel>{
                        BaseUnitName: metric.BaseUnitName,
                        QtyPerUnit: metric.QtyPerUnit,
                        Size: metric.Size,
                        Subsize: metric.Subsize,
                        Unit: metric.Unit,
                        ShowUnitOnWebshop: metric.ShowUnitOnWebshop,
                        OldModelSelection: metric.OldModelSelection
                    });


                    try {
                        let foundPorterItem = porterBuilder.state.porterItems.porterItems.find(x => x.porterItem.itemNo == result.productVariants[i].itemNumber);
                        if (foundPorterItem && foundPorterItem.porterItem) {

                            variantIsOldModel = foundPorterItem.porterItem.isOldModelSales;
                        }

                    } catch (e) {
                        console.log(e);
                    }
                    if (this.subsizes.includes(metric.Subsize) && this.sizes.includes(metric.Size)) {
                        this.productMatrix[this.subsizes.indexOf(metric.Subsize)][this.sizes.indexOf(metric.Size)] =
                            {
                                num: result.productVariants[i].itemNumber,
                                variant: result.productVariants[i].productVariantId,
                                isOldModelSalesPorter: variantIsOldModel
                            };

                    }
                    
                    //Base unit is the same for each row in the matrix
                    this.baseUnit = metric.BaseUnitName;

                 

                }
                this.sizes = this.sizes.filter(distinct);

                //this.units = this.units.filter(distinct);
                //this.allUnits = this.allUnits.filter(x=>x.ShowUnitOnWebshop);
                this.allUnits = this.allUnits.filter(distinctUnit);
                this.shouldLoadMatrix = false;
                this.setLoaded();
            })
            .catch(e => {
                this.setError(e);
            });

        const distinct = (value: any, index: any, self: any) => {
            return self.indexOf(value) === index;
        }
        const distinctUnit = (value: IBasicMetricViewModel, index: number, collection: IBasicMetricViewModel[]) => {
            return collection.map(x => x.Unit).indexOf(value.Unit) === index;
        }
    }
}

export interface IBasicMetricViewModel {
    BaseUnitName: string;
    OldModelSelection: boolean;
    QtyPerUnit: number;
    ShowUnitOnWebshop: boolean;
    Size: string;
    Subsize: string;
    Unit: string;
}
Vue.component('product-matrix', ProductMatrixComponent);